<template>
  <div>
    <Head title="Tambah Persyaratan Pertanggung Jawaban" />
    <h1 class="mb-8 text-2xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/persyaratan-pertanggungjawabans">Persyaratan Pertanggung Jawaban </Link>
      <span class="text-indigo-400 font-medium">/</span> Tambah Data
    </h1>
    <div class="w-full bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.nama" :error="form.errors.nama" class="pb-8 pr-6 w-full" label="Nama Persyaratan" />

          <div class="pb-8 pr-6 w-full lg:w-1/3 flex">
            <input id="is_required" v-model="form.is_required" type="checkbox" class="mr-2" />
            <label for="is_required" class="flex flex-row items-center cursor-pointer">
              Wajib
            </label>
          </div>
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">
            <font-awesome-icon class="mr-2" icon="fas fa-key" />Simpan
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    TextInput,
  },
  layout: Layout,
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        nama: null,
        is_required: true,
      }),
    }
  },
  methods: {
    store() {
      this.form.post(this.route('persyaratan-pertanggungjawabans.store'))
    },
  },
}
</script>
